import { get } from '@eika-infrastruktur/request';
import { RequestException } from '@eika-infrastruktur/request/src/exceptions';
import { CONTEXT_PATH } from './index';
export const SERVICE_PATH = 'rest/resource/keepalive';
const keepAlive = async (context) => {
    try {
        await get(`${CONTEXT_PATH}/${SERVICE_PATH}/?context=${context}`);
        return true;
    }
    catch (exception) {
        if (exception instanceof RequestException) {
            if (exception.status === 403 || exception.status === 401) {
                return false;
            }
        }
        return true;
    }
};
export default keepAlive;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2VlcEFsaXZlU2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZXJ2aWNlcy9rZWVwQWxpdmVTZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUNsRCxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSw0Q0FBNEMsQ0FBQztBQUc5RSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBRXZDLE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyx5QkFBeUIsQ0FBQztBQUV0RCxNQUFNLFNBQVMsR0FBRyxLQUFLLEVBQUUsT0FBZ0IsRUFBb0IsRUFBRTtJQUMzRCxJQUFJLENBQUM7UUFDRCxNQUFNLEdBQUcsQ0FBb0IsR0FBRyxZQUFZLElBQUksWUFBWSxhQUFhLE9BQU8sRUFBRSxDQUFDLENBQUM7UUFDcEYsT0FBTyxJQUFJLENBQUM7SUFDaEIsQ0FBQztJQUFDLE9BQU8sU0FBa0IsRUFBRSxDQUFDO1FBQzFCLElBQUksU0FBUyxZQUFZLGdCQUFnQixFQUFFLENBQUM7WUFDeEMsSUFBSSxTQUFTLENBQUMsTUFBTSxLQUFLLEdBQUcsSUFBSSxTQUFTLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDO2dCQUN2RCxPQUFPLEtBQUssQ0FBQztZQUNqQixDQUFDO1FBQ0wsQ0FBQztRQUNELE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixlQUFlLFNBQVMsQ0FBQyJ9